import { BASIC_TOUR_STEPS, CHARTER_TOUR_STEPS, FILTER_FORM_STEPS } from 'constants/constant';

export const PreviewElementSteps = [
	{
		target: '#accordian-time',
		content: (
			<div style={{ textAlign: 'left' }}>
				<div style={{ fontWeight: 'bold' }}>{CHARTER_TOUR_STEPS.STEP1}</div>
				<br />
				<div>{CHARTER_TOUR_STEPS.STEP1_DESC}</div>
			</div>
		),
		placement: 'left',
		locale: {
			skip: '1/4'
		},
		disableBeacon: true,
		spotlightClicks: true,
		hideCloseButton: true,
		disableScrollParentFix: true
	},
	{
		target: '#accordian-1',
		content: (
			<div style={{ textAlign: 'left' }}>
				<div style={{ fontWeight: 'bold' }}>{CHARTER_TOUR_STEPS.STEP2}</div>
				<br />
				<div>{CHARTER_TOUR_STEPS.STEP2_DESC}</div>
			</div>
		),
		placement: 'left',
		locale: {
			skip: '2/4'
		},
		disableBeacon: true,
		spotlightClicks: true,
		hideCloseButton: true,
		disableScrollParentFix: true
	},
	{
		target: '#filter-txt-lbl',
		content: (
			<div style={{ textAlign: 'left' }}>
				<div style={{ fontWeight: 'bold' }}>{CHARTER_TOUR_STEPS.STEP3}</div>
				<br />
				<div>{CHARTER_TOUR_STEPS.STEP3_DESC}</div>
			</div>
		),
		placement: 'left',
		locale: {
			skip: '3/4'
		},
		disableBeacon: true,
		spotlightClicks: true,
		hideCloseButton: true,
		disableScrollParentFix: true
	},
	{
		target: '#btn-preview',
		content: (
			<div style={{ textAlign: 'left' }}>
				<div style={{ fontWeight: 'bold' }}>{CHARTER_TOUR_STEPS.STEP4}</div>
				<br />
				<div>{CHARTER_TOUR_STEPS.STEP4_DESC}</div>
			</div>
		),
		placement: 'left',
		locale: {
			skip: '4/4',
			last: CHARTER_TOUR_STEPS.GOT_IT
		},
		disableBeacon: true,
		spotlightClicks: true,
		hideCloseButton: true,
		disableScrollParentFix: true
	}
];

export const PreviewElementStepsWOTime = [
	{
		target: '#accordian-1',
		content: (
			<div style={{ textAlign: 'left' }}>
				<div style={{ fontWeight: 'bold' }}>{CHARTER_TOUR_STEPS.STEP2}</div>
				<br />
				<div>{CHARTER_TOUR_STEPS.STEP2_DESC}</div>
			</div>
		),
		placement: 'left',
		locale: {
			skip: '1/3'
		},
		disableBeacon: true,
		spotlightClicks: true,
		hideCloseButton: true,
		disableScrollParentFix: true
	},
	{
		target: '#filter-txt-lbl',
		content: (
			<div style={{ textAlign: 'left' }}>
				<div style={{ fontWeight: 'bold' }}>{CHARTER_TOUR_STEPS.STEP3}</div>
				<br />
				<div>{CHARTER_TOUR_STEPS.STEP3_DESC}</div>
			</div>
		),
		placement: 'left',
		locale: {
			skip: '2/3'
		},
		disableBeacon: true,
		spotlightClicks: true,
		hideCloseButton: true,
		disableScrollParentFix: true
	},
	{
		target: '#btn-preview',
		content: (
			<div style={{ textAlign: 'left' }}>
				<div style={{ fontWeight: 'bold' }}>{CHARTER_TOUR_STEPS.STEP4}</div>
				<br />
				<div>{CHARTER_TOUR_STEPS.STEP4_DESC}</div>
			</div>
		),
		placement: 'left',
		locale: {
			skip: '3/3',
			last: CHARTER_TOUR_STEPS.GOT_IT
		},
		disableBeacon: true,
		spotlightClicks: true,
		hideCloseButton: true,
		disableScrollParentFix: true
	}
];

export const FilterFormSteps = [
	{
		target: '#toolbar-back',
		content: (
			<div style={{ textAlign: 'left' }}>
				<div style={{ fontWeight: 'bold' }}>{FILTER_FORM_STEPS.STEP1}</div>
				<br />
				<div>{FILTER_FORM_STEPS.STEP1_DESC}</div>
			</div>
		),
		placement: 'left',
		disableBeacon: true,
		spotlightClicks: true,
		hideCloseButton: true,
		disableScrollParentFix: true
	}
];

export const BasicPreviewElementSteps = [
	{
		target: '#accordian-time',
		content: (
			<div style={{ textAlign: 'left' }}>
				<div style={{ fontWeight: 'bold' }}>{BASIC_TOUR_STEPS.STEP1}</div>
				<br />
				<div>{BASIC_TOUR_STEPS.STEP1_DESC}</div>
			</div>
		),
		placement: 'left',
		locale: {
			skip: '1/4'
		},
		disableBeacon: true,
		spotlightClicks: true,
		hideCloseButton: true,
		disableScrollParentFix: true
	},
	{
		target: '#accordian-1',
		content: (
			<div style={{ textAlign: 'left' }}>
				<div style={{ fontWeight: 'bold' }}>{BASIC_TOUR_STEPS.STEP2}</div>
				<br />
				<div>{BASIC_TOUR_STEPS.STEP2_DESC}</div>
			</div>
		),
		placement: 'left',
		locale: {
			skip: '2/4'
		},
		disableBeacon: true,
		spotlightClicks: true,
		hideCloseButton: true,
		disableScrollParentFix: true
	},
	{
		target: '#filter-txt-lbl',
		content: (
			<div style={{ textAlign: 'left' }}>
				<div style={{ fontWeight: 'bold' }}>{BASIC_TOUR_STEPS.STEP3}</div>
				<br />
				<div>{BASIC_TOUR_STEPS.STEP3_DESC}</div>
			</div>
		),
		placement: 'left',
		locale: {
			skip: '3/4'
		},
		disableBeacon: true,
		spotlightClicks: true,
		hideCloseButton: true,
		disableScrollParentFix: true
	},
	{
		target: '#btn-schedule',
		content: (
			<div style={{ textAlign: 'left' }}>
				<div style={{ fontWeight: 'bold' }}>{BASIC_TOUR_STEPS.STEP4}</div>
				<br />
				<div>{BASIC_TOUR_STEPS.STEP4_DESC}</div>
			</div>
		),
		placement: 'left',
		locale: {
			skip: '4/4',
			last: BASIC_TOUR_STEPS.GOT_IT
		},
		disableBeacon: true,
		spotlightClicks: true,
		hideCloseButton: true,
		disableScrollParentFix: true
	}
];

export const BasicPreviewElementStepsWOTime = [
	{
		target: '#accordian-1',
		content: (
			<div style={{ textAlign: 'left' }}>
				<div style={{ fontWeight: 'bold' }}>{CHARTER_TOUR_STEPS.STEP2}</div>
				<br />
				<div>{CHARTER_TOUR_STEPS.STEP2_DESC}</div>
			</div>
		),
		placement: 'left',
		locale: {
			skip: '1/3'
		},
		disableBeacon: true,
		spotlightClicks: true,
		hideCloseButton: true,
		disableScrollParentFix: true
	},
	{
		target: '#filter-txt-lbl',
		content: (
			<div style={{ textAlign: 'left' }}>
				<div style={{ fontWeight: 'bold' }}>{CHARTER_TOUR_STEPS.STEP3}</div>
				<br />
				<div>{CHARTER_TOUR_STEPS.STEP3_DESC}</div>
			</div>
		),
		placement: 'left',
		locale: {
			skip: '2/3'
		},
		disableBeacon: true,
		spotlightClicks: true,
		hideCloseButton: true,
		disableScrollParentFix: true
	},
	{
		target: '#btn-schedule',
		content: (
			<div style={{ textAlign: 'left' }}>
				<div style={{ fontWeight: 'bold' }}>{BASIC_TOUR_STEPS.STEP4}</div>
				<br />
				<div>{BASIC_TOUR_STEPS.STEP4_DESC}</div>
			</div>
		),
		placement: 'left',
		locale: {
			skip: '3/3',
			last: BASIC_TOUR_STEPS.GOT_IT
		},
		disableBeacon: true,
		spotlightClicks: true,
		hideCloseButton: true,
		disableScrollParentFix: true
	}
];
